import styled from 'styled-components';
import { SearchBar } from 'components';

export const StyledFilterButtonContainer = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: auto auto;
  gap: 5px;
`;

export const StyledListingsSearchWrapper = styled.div<{ $isMobile: boolean }>`
  ${({ $isMobile }) => $isMobile && `width: 100%`};
`;

export const StyledOpenHousesSearchWrapper = styled.div<{ $stretch: boolean }>`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-column-gap: 10px;
  ${({ $stretch }) => $stretch && `width: 100%`};
`;

export const StyledHavesWantsSearchWrapper = styled.div<{
  $wrap: boolean;
  $stretch: boolean;
  $singleColumn: boolean;
}>`
  display: grid;
  grid-template-columns: 1fr 160px 160px auto;
  grid-column-gap: 10px;
  grid-row-gap: 5px;
  ${({ $wrap, $stretch, $singleColumn }) => {
    if ($singleColumn) {
      return `
        grid-template-columns: 1fr;
      `;
    }
    if ($wrap) {
      return `
      grid-template-columns: ${$stretch ? 'repeat(4, 1fr)' : 'repeat(4, 80px)'};
      ${$stretch && 'width: 100%'};
      > * {
        grid-column-end: span 2;
      }
      > ${SearchBar} {
        grid-column-end: span 3;
      }
      a {
        grid-row-start: 1;
        grid-column-start: 4;
        grid-column-end: 5;
        > button {
          display: block;
          width: 100%;
        }
      }
    `;
    }
    return '';
  }}
`;
